import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Waves } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { useSEO } from "../../lib/seo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  useSEO({ title: "Admin", description: "", noindex: true });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 justify-center mb-8">
          <span className="w-10 h-10 rounded-full bg-sky-500 flex items-center justify-center">
            <Waves className="w-5 h-5 text-white" aria-hidden="true" />
          </span>
          <span className="font-heading font-bold text-white text-lg">Admin Panel</span>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2.5 rounded-md border border-border text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-2.5 rounded-md border border-border text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
            />
          </div>
          {error && <p className="text-sm text-rose-600" data-testid="login-error-message">{error}</p>}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-md bg-sky-500 text-white font-semibold text-sm hover:bg-sky-600 active:scale-95 disabled:opacity-50 transition-colors duration-200"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
